// The one Supabase client for the SPA.
//
// This uses the PUBLISHABLE key, which is safe in a browser precisely because RLS decides what
// it can see: an anonymous holder of this key gets nothing at all, and a signed-in admin gets
// exactly the rows the policies allow. The secret key never comes near this bundle — CI greps
// the build output for it.

import { createClient } from '@supabase/supabase-js';

const url = import.meta.env['VITE_SUPABASE_URL'];
const publishableKey = import.meta.env['VITE_SUPABASE_PUBLISHABLE_KEY'];

/** True when the app has been built with its Supabase configuration. */
export const isConfigured = Boolean(url && publishableKey);

/**
 * True when running in local demo/offline preview mode.
 *
 * The localStorage switch is honoured in dev builds only. In the deployed app anyone could set
 * it from the console and get past the login gate into a screen of invented dentists with
 * invented phone numbers under a "На живо" badge.
 */
export const isDemoMode =
  !isConfigured ||
  (import.meta.env.DEV &&
    typeof window !== 'undefined' &&
    localStorage.getItem('leadg_demo_mode') === 'true');

export const supabase = createClient(
  url ?? 'https://unconfigured.invalid',
  publishableKey ?? 'anon',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
);
